import React from "react";
import { Chip, Stack, Typography } from "@mui/material";
import { EMAIL_PLACEHOLDERS, toToken } from "./emailUtils";

const PlaceholderBar = ({ onInsert }) => (
  <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1}>
    <Typography variant="caption" color="text.secondary">
      Insert placeholder:
    </Typography>
    {EMAIL_PLACEHOLDERS.map((p) => (
      <Chip
        key={p.key}
        size="small"
        variant="outlined"
        label={toToken(p.key)}
        title={p.label}
        onMouseDown={(e) => e.preventDefault()} // keep focus in the field/editor
        onClick={() => onInsert(p.key)}
      />
    ))}
  </Stack>
);

export default PlaceholderBar;
